<template>
  <div>
    <input type="hidden" name="_token" :value="csrf" />
    <input v-if="this.editing" type="hidden" name="_method" value="PUT" />
    <div class="row align-items-center px-3 mb-5 mt-5 ml-3 mr-3" v-if="job_affiliation">

      <div :class="'card p-2 border-card shadow col-' + col_size_card">
        <p class="text-primary">{{ __("forms.questionsLabel.affinityPosition") }}</p>
        <p class="text-right h3">
          {{ taxRoleAffiliation }}%
        </p>
      </div>

      <div :class="'card p-2 border-card shadow col-' + col_size_card" v-if="show_arithmetic_avg">
        <p class="text-primary">{{ __("forms.questionsLabel.arithmeticAverage") }}</p>
        <p class="text-right h3">
          {{ arithmeticAverage }}
        </p>
      </div>
      <!-- <div class="col-8 px-4 mt-2"> -->
      <div :class="'px-4 mt-2 col-' + col_size_progress_bar">
        <span class="progress shadow mt-3 mr-3" style="height: 2rem; border-radius: 10px">
          <div class="progress-bar" role="progressbar" :style="{
            width: taxRoleAffiliation + '%',
            backgroundColor: colorBar,
            textAlign: 'right',
            paddingRight: 15 + 'px',
            color: 'white',
          }">{{ taxRoleAffiliation }}%</div>
        </span>
      </div>
    </div>
    <div class="row align-items-center px-3 mb-5 mt-5 ml-3 mr-3" v-if="!job_affiliation && show_arithmetic_avg">
      <div class="card p-2 border-card shadow col-12">
        <p class="text-primary">{{ __("forms.questionsLabel.arithmeticAverage") }}</p>
        <p class="text-right h3">
          {{ arithmeticAverage }}
        </p>
      </div>
    </div>

    <div class="row px-3 mt-2 mb-2">
      <div class="col-12">
        <div class="table--custom">
          <div class="single--row single--row-head single--row-head--mini">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <div class="single--row-info">
                  {{ __("forms.EvaluationChart.questions.questions_setting.question7.label") }}
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12" v-if="!hide_required_level">
                <div class="single--row-info">
                  {{ __("forms.EvaluationChart.questions.questions_setting.question7.level") }}
                </div>
              </div>
              <div :class="[!hide_required_level ? 'col-lg-2 col-md-2 col-12' : 'col-lg-3 col-md-3 col-12']">
                <div class="single--row-info">
                  {{ __("forms.EvaluationChart.questions.questions_setting.question7.evaluation") }}
                </div>
              </div>
              <div :class="[!hide_required_level ? 'col-lg-2 col-md-2 col-12' : 'col-lg-3 col-md-3 col-12']">
                <div class="single--row-info">
                  {{ __("forms.EvaluationChart.questions.questions_setting.question7.status") }}
                </div>
              </div>
            </div>
          </div>
          <div class="single--row single--row-input">
            <div class="row single--row-input-content" v-for="row in table_data" :key="row.id">
              <div class="col-lg-6 col-md-6 col-12 mt-4">
                <div style="font-size: 14px;" class="single--row-info-group ml-3">
                  {{ row.label }}
                  <a style="height : 20px !important;" v-if="row.note !== null && row.note !== ''"
                    class="btn bg-transparent text-info float-right" @click="openNote(row.note)">
                    <i style="font-size: 14px" class="fas fa-info-circle colored-icon"></i>
                  </a>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12" v-if="!hide_required_level">
                <div class="single--row-info" style="border-left:1px solid #DFE6F6 !important;">{{ row.level_name }}
                </div>
              </div>
              <div :class="[!hide_required_level ? 'col-lg-2 col-md-2 col-12' : 'col-lg-3 col-md-3 col-12']">
                <div class="single--row-info" style="padding-right: 10px; padding-left: 10px;">
                  <select class="form-control" :disabled="level_permission['disabled']"
                    :class="level_permission['classRequired']" :required="level_permission['required']" :name="'question[' + question_survey_id + '][' + row.id + ']'
                      " v-model="colors[row.id]['answer']" @change="changeLevel($event, row.id)">
                    <option value="null">---</option>
                    <option v-for="option in levels" :key="option.id" v-bind:value="option.id">
                      {{ option.title }}
                    </option>
                    <option value="-99" v-if="show_not_evaluable_level">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question19.na") }}
                    </option>
                  </select>
                </div>
              </div>
              <div :class="[!hide_required_level ? 'col-lg-2 col-md-2 col-12' : 'col-lg-3 col-md-3 col-12']">
                <div class="single--row-info">
                  <div v-html="colors[row.id].delta"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.roundColor {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border-style: solid;
  border-color: black;
}

.table--custom .single--row-head {
  background: #559bd9;
}
</style>

<script>
export default {
  created() {

    if (this.show_arithmetic_avg) {
      this.col_size_card = 6;
    } else {
      this.col_size_card = 12;
    }

    this.col_size_progress_bar = 12;

    this.keysColor = Object.keys(this.colors_delta);

    for (var i = 0; i < this.keysColor.length; i++) {
      this.keysColor[i] = parseInt(this.keysColor[i]);
    }

    this.colors = this.deltas;
    for (let index in this.colors) {
      this.colors[index]["delta"] = null;

      //set temporally null values when empty_values is true
      if (this.empty_values) {
        this.colors[index]["answer"] = null;
      }

      if (this.colors[index]["answer"] !== null) this.changeColorRound(index);
    }
  },
  computed: {
    colorBar() {
      let color = "";
      if (this.taxRoleAffiliation < 34) {
        color = "#F04649";
      } else if (this.taxRoleAffiliation < 67) {
        color = "#FFA800";
      } else {
        color = "#2A9D8F";
      }
      return color;
    },
  },
  mounted() {
    this.taxJobAffiliation();
  },
  props: {
    level_permission: {
      type: Object,
      required: true,
    },
    levels: {
      type: Array,
      required: true,
    },
    table_data: {
      type: Array,
      required: true,
    },
    deltas: {
      type: Object,
      required: true,
    },
    colors_delta: {
      type: Object,
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: false,
    },
    show_not_evaluable_level: {
      type: Boolean,
      required: false,
      default: true,
    },
    show_arithmetic_avg: {
      type: Boolean,
      required: false,
      default: false,
    },
    job_affiliation: {
      type: Boolean,
      required: false,
      default: false,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
    hide_required_level: {
      type: Boolean,
      required: true,
    },
    array_weight_skill_levels_id: {
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {
      keysColor: [],
      test: "#FF0000",
      level_list: [],
      colors: [],
      colorsRound: [],
      taxRoleAffiliation: 0,
      arithmeticAverage: 0,
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),

      col_size_card: 4,
      col_size_progress_bar: 8,
    };
  },
  methods: {
    changeLevel(event, index) {
      this.changeColorRound(index);
      this.taxJobAffiliation();
    },
    taxJobAffiliation() {
      axios
        .post("/cover-role-rate", {
          arraySkillLevel: this.colors,
        })
        .then((response) => {
          this.taxRoleAffiliation = response.data.taxRoleAffiliation;
          this.arithmeticAverage = response.data.arithmeticAverage;
        });
    },
    openNote(note) {
      Vue.swal.fire({
        title: note,
      });
    },
    changeColorRound(index) {
      index = parseInt(index);
      var divHtml = "<div class='shadow' style='width: 24px;height: 24px;background-color:{backgroundColor} ;border-radius: 50%;'></div>";
      let color = null;

      if (this.colors[index]["answer"] === null || this.colors[index]["answer"] === "null") {
        color = "#FFFFFF";
      } else if (this.colors[index]["answer"] === "-99") {
        color = "#A8A8A8";
      } else {
        let answerWeight =
          this.array_weight_skill_levels_id[this.colors[index]["answer"]];
        let requiredWeight =
          this.array_weight_skill_levels_id[this.colors[index]["required"]];
        let deltaN = answerWeight - requiredWeight;

        if (this.keysColor.includes(deltaN)) {
          color = this.colors_delta[deltaN];
        } else if (deltaN < 0) {
          color = this.colors_delta["-10"];
        } else {
          color = this.colors_delta["10"];
        }
      }
      this.colors[index]["delta"] = divHtml.replace("{backgroundColor}", color);
      return;
    },
  },
};
</script>
